import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-overdue2",
  "use": "icon-overdue2-usage",
  "viewBox": "0 0 13 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 13 15\" id=\"icon-overdue2\">\n    <path fill=\"currentColor\" d=\"M.264 0C.11.027-.002.154 0 .3v13.2c0 .165.146.3.325.3H1.3v.9c0 .165.146.3.325.3h11.05c.179 0 .325-.135.325-.3V1.5c0-.165-.146-.3-.325-.3H11.7V.3c0-.165-.146-.3-.325-.3H.265zM.65.6h10.4v12.6H.65V.6zM11.7 1.8h.65v12.6H1.95v-.6h9.425c.179 0 .325-.135.325-.3V1.8zM6.175 5.1v.6h2.133L5.85 7.969l-1.066-.985-.234-.206-.234.206-2.275 2.1.468.432L4.55 7.63l1.066.985.234.206.234-.206L8.775 6.13V8.1h.65v-3h-3.25z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol